module.exports = __webpack_public_path__ + "media/img/event/sponsor/ucam-logo-34422446d638a6e61bb2536a0dbd7afb.png";